export const commonMultiselectProps = {
  limitTags: 1,
  selectOnFocus: true,
  autoHighlight: true,
  disableCloseOnSelect: true,
  disableListWrap: true,
};
